<span class="uikit-icon">
    <ng-content select="svg">
      <svg [attr.class]="'insight-' + icon">
        <use [attr.xlink:href]="symbolPath + '#insight-' + icon" [attr.href]="symbolPath + '#insight-' + icon"></use>
      </svg>
    </ng-content>
</span>
